//'use strict';


/** Add any additional Requirements to the Controller here and they will be added to the module Requires array
 */
var additionalRequirementsForModule = [ 'ui.bootstrap' ];
Array.prototype.push.apply(bookModule.requires, additionalRequirementsForModule);


bookModule.controller('curriculumController', 
    ['$scope', '$controller', '$location', '$state', '$document', '$uibModal', '$http', 'contentService',
    function ($scope, $controller, $location, $state, $document, $uibModal, $http, contentService) {
        // Initialize the parent class and extend it.
        angular.extend(this, $controller('abstractController', {$scope: $scope}) );
        var vm = $scope.ctrl;

        /** @Override - ensure that the pathway is set to undefined at intial load
         * this method can be used to setup the controller after the contents has been loaded
         */
        vm.controllerSetup = function() {
            vm.pathwayChar = undefined;
        };

        /** method to check if a criteria is of the the same type as the currently selected pathway
         */
        vm.isCriteriaSameTypeAsCurrentPathway = function (outcomeChapter) {
            return outcomeChapter.charAt(outcomeChapter.length - 1) === vm.pathwayChar;
        }

        /** watches the pathwayChar to ensure that ui-router will update the state when the pathway changes
         */
        $scope.$watch('ctrl.pathwayChar', function() {
            if (typeof vm.pathwayChar !== 'undefined') {
                $state.go('matrix.dictionary', 
                    { 
                        chapterString: vm.chapterString, 
                        pathwayString: vm.getPathwayUrlString(), 
                        dictionaryTerm: vm.dictionaryTerm 
                    }
                );
            }
        });

        /** dictionary of pathways and the associated titles and url parts.
         */
        vm.pathwayDictionary = {
            a : { title: 'Pre-general practice', urlString: 'pre-gp' },
            b : { title: 'General practice under supervision', urlString: 'gp-under-supervision' },
            c : { title: 'General practice - lifelong learning', urlString: 'gp-lifelong-learning' },
        };
        /** Returns the title of the currently selected pathway.
         */
        vm.getPathwayTitle = function() {
            return (vm.pathwayDictionary[vm.pathwayChar] != undefined) 
                ? vm.pathwayDictionary[vm.pathwayChar].title 
                : "";
        };

        /** gets the associated urlString for the current pathway
         */
        vm.getPathwayUrlString = function() {
            return (vm.pathwayDictionary[vm.pathwayChar] != undefined) 
                ? vm.pathwayDictionary[vm.pathwayChar].urlString 
                : undefined;
        }

        /** gets the pathway char for the input pathwayUrlString
         */
        function getPathwayCharByUrlString(pathwayUrlString){
            for(var key in vm.pathwayDictionary) {
                if(vm.pathwayDictionary[key].urlString == pathwayUrlString){
                    return key;
                }
            }
            return undefined;
        };


        /** returns true if any Domain is currently open
         */
        vm.isAnyDomainOpen = function() {
            return typeof vm.openDomainIndex !== 'undefined';
        }        
        /** returns true if any CoreSkill is currently open
         */
        vm.isAnyCoreSkillOpen = function() {
            return typeof vm.openSkillIndex !== 'undefined';
        }        
        /** returns true if any CoreSkill is currently open
         */
        vm.isAnyOutcomeOpen = function() {
            return typeof vm.openOutcomeIndex !== 'undefined';
        }
        /** returns true if any Criteria is currently open
         */
        vm.isAnyCriteriaOpen = function() {
            return typeof vm.openCriteriaIndex !== 'undefined';
        }

        /** returns a string representation of the deepest selected state
         * This method is used to apply different bootstrap classes to the grid/matrix
         */
        vm.getDeepestSelectedState = function () {
            if (vm.isAnyCriteriaOpen())
                return "criteria";
            if (vm.isAnyOutcomeOpen())
                return "outcome";
            if (vm.isAnyCoreSkillOpen())
                return "coreskill";
            if (vm.isAnyDomainOpen())
                return "domain";
            return "none";
        }

        /** @Override
         * This method will ensure that all of the params are read correctly when navigating to the page or changing state
         */
        vm.updateControllerStateParams = function(toParams) {
            vm.chapterString = toParams.chapterString;
            // if the chaperString is empty or 'home' then we cannot be in a valid state
            var hasNonEmptyChapterString = typeof vm.chapterString !== 'undefined' 
            && vm.chapterString.length > 0
            && vm.chapterString !== 'home';
            var chapterStringArray = hasNonEmptyChapterString
                ? vm.chapterString.toLowerCase().split('.') 
                : undefined;
            vm.openDomainIndex = vm.parseDomainUrlStringToDomainIndex(chapterStringArray);
            vm.openSkillIndex = vm.parseSkillUrlStringToSkillIndex(chapterStringArray);
            vm.openOutcomeIndex = vm.parseOutcomeUrlStringToOutcomeIndex(chapterStringArray);
            vm.openCriteriaIndex = vm.parseCriteriaUrlStringToCriteriaIndex(chapterStringArray);

            vm.pathwayChar = vm.parsePathwayUrlStringToChar(toParams.pathwayString);

            vm.dictionaryTerm = toParams.dictionaryTerm;
        };

        /** returns the Domain index (int) associated with the current Domain in the url
         */
        vm.parseDomainUrlStringToDomainIndex = function(chapterStringArray) {
            if (chapterStringArray == undefined) return undefined;
            var domainString = chapterStringArray[0].replace(/\D/g,'');
            var domainIndex = parseInt(domainString)-1;
            return domainIndex;
        };
        /** returns the Core Skill index (int) associated with the current Core Skill in the url
         */
        vm.parseSkillUrlStringToSkillIndex = function(chapterStringArray) {
            if (chapterStringArray == undefined)  return undefined;
            var skillsString = chapterStringArray[1];
            var skillsIndex = skillsString == undefined ? undefined : parseInt(skillsString)-1;
            return skillsIndex;
        };
        /** returns the Outcome index (int) associated with the current Outcome in the url
         */
        vm.parseOutcomeUrlStringToOutcomeIndex = function(chapterStringArray) {
            if (chapterStringArray == undefined)  return undefined;
            var outcomeString = chapterStringArray[2];
            var outcomeIndex = outcomeString == undefined ? undefined : parseInt(outcomeString)-1;
            return outcomeIndex;
        };
        /** returns the Criteria index (int) associated with the current Criteria in the url
         */
        vm.parseCriteriaUrlStringToCriteriaIndex = function(chapterStringArray) {
            if (chapterStringArray == undefined)  return undefined;
            var criteriaString = chapterStringArray[3];
            var criteriaIndex = criteriaString == undefined ? undefined : parseInt(criteriaString.substring(0,criteriaString.length-1))-1;
            return criteriaIndex;
        };
        /** returns the Pathway char associated with the current Pathway in the url
         */
        vm.parsePathwayUrlStringToChar = function(pathwayString) {
            if (pathwayString == undefined)  return undefined;
            var pathwayChar = getPathwayCharByUrlString(pathwayString);
            return pathwayChar;
        };

        /** returns the content node for the current deepest open node. returns undefined if no node is open
         */
        vm.getOpenContentNode = function() {
            if (vm.isAnyCriteriaOpen())
                return vm.getOpenCriteraContentNode();
            if (vm.isAnyOutcomeOpen())
                return vm.getOpenOutcomeContentNode();
            if (vm.isAnyCoreSkillOpen())
                return vm.getOpenCoreSkillContentNode();
            if (vm.isAnyDomainOpen())
                return vm.getOpenDomainContentNode();
            return undefined;
        };
        /** returns the content node for the current Domain node
         */
        vm.getOpenDomainContentNode = function() {
            if (vm.openDomainIndex == undefined) return undefined;
            var domainContentNode = $scope.contents.domains[vm.openDomainIndex];
            return domainContentNode;
        };
        /** returns the content node for the current Core Skill node
         */
        vm.getOpenCoreSkillContentNode = function() {
            if (vm.openSkillIndex == undefined) return undefined;
            var openDomainNode = vm.getOpenDomainContentNode();
            if (openDomainNode == undefined) return undefined;
            var skillContentNode = openDomainNode.children[vm.openSkillIndex];
            return skillContentNode;
        };
        /** returns the content node for the current Outcome node
         */
        vm.getOpenOutcomeContentNode = function() {
            if (vm.openOutcomeIndex == undefined) return undefined;
            var openCoreSkillNode = vm.getOpenCoreSkillContentNode();
            if (openCoreSkillNode == undefined) return undefined;
            var skillContentNode = openCoreSkillNode.children[vm.openOutcomeIndex];
            return skillContentNode;
        };
        /** returns the content node for the current Criteria node
         */
        vm.getOpenCriteraContentNode = function() {
            if (vm.openCriteriaIndex == undefined) return undefined;
            var openOutcomeNode = vm.getOpenOutcomeContentNode();
            if (openOutcomeNode == undefined) return undefined;
            var criteriaContentNode = undefined;
            openOutcomeNode.children.some( function ( obj , index )
            {
                var objCriteriaIndex = vm.parseCriteriaUrlStringToCriteriaIndex(obj.chapter.split('.'));
                var isObjMatchingCriteriaIndex = (objCriteriaIndex === vm.openCriteriaIndex);

                var isObjMatchingOutcomeStageChar = vm.isCriteriaSameTypeAsCurrentPathway(obj.chapter);
                
                if ( isObjMatchingCriteriaIndex && isObjMatchingOutcomeStageChar )
                {
                    criteriaContentNode = obj;
                    return true;
                }
            } );
            return criteriaContentNode;
        };

        function checkIfInView(element){
            var offset = element.offset().top - $(window).scrollTop();

            if(offset > window.innerHeight){
                // Not in view so scroll to it
                $('html,body').animate({scrollTop: offset}, 1000);
                return false;
            }
            return true;
        }

        /** https://angular-ui.github.io/bootstrap/
         * @author  AngularUI Team
         * @version 2.1.3
         * 
         * Opens a ui-bootstrap modal (uibModal)
         * @templateUrl the url of the tempalate to use to fill the modal
         * @disableClickOffToCLose determines if the modal can be closed by clicking on the background
         */
        function openModal(templateUrl, windowClass, disableClickOffToCLose) {
            var template = $http.get(templateUrl)
                .then(function(result) {
                    return contentService.extractKenticoContentFromString(result.data);
                });

            var modalInstance = $uibModal.open({
                windowClass: windowClass + " show curriculum-modal",
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                template: template,
                backdrop: disableClickOffToCLose ? 'static' : 'true',
                backdropClass: 'show',
                controller: 'ModalInstanceCtrl',
                resolve: {
                    activePathwayUrlString: function() {
                        return vm.getPathwayUrlString();
                    }
                }
            });
            return modalInstance;
        };

        /** opens a ui-bootstrap modal (uibModal) containing to references for the currently open domain
         */
        vm.OpenReferenceModalForCurrentDomain = function (referenceName) {
            var templateUrl = './../common/references/' + referenceName + '.html';
            openModal(templateUrl, 'references-modal');
        };
        
        /** opens a ui-bootstrap modal (uibModal) with the introduction
         */
        vm.openIntroduction = function () {
            var templateUrl = './../common/templates/introduction.html';
            var disableClickOffToCLose = isEmpty(vm.pathwayChar);

            var modalInstance = openModal(templateUrl, 'introduction-modal', disableClickOffToCLose);

            modalInstance.result.then(function (result) {
                vm.pathwayChar = vm.parsePathwayUrlStringToChar(result);
            });
        };

        /** opens a ui-bootstrap modal (uibModal) with the introduction
         */
        vm.initialPageLoad = function() {
            if (typeof vm.pathwayChar === 'undefined')
            {
                vm.openIntroduction();
            }
        };

        function isEmpty(string) {
            return (string && string.length > 0);
        };
    } ]
);


/** https://angular-ui.github.io/bootstrap/
 * @author  AngularUI Team
 * @version 2.1.3
 * 
 * Adds a controller for the modal that will keep the Pathway up to date
 * @activePathwayUrlString the string returned from the modal using the ui-modal $close(string) method
 */
bookModule.controller('ModalInstanceCtrl',
    [ '$scope', 'activePathwayUrlString',
    function ($scope, activePathwayUrlString) {
        $scope.activePathwayUrlString = activePathwayUrlString;
    } ]
);